import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Onlinetaxibookingmumbai() {



const cardData = {
  keyword: " Online Taxi Booking Mumbai",

headingDescription:
  "Omshree Cab offers reliable and convenient online taxi booking in Mumbai for travelers who want quick, safe, and comfortable transportation across the city. Whether you need a cab for airport transfers, business meetings, city tours, family outings, or outstation travel, our online booking system makes it easy to reserve your ride in just a few steps. We provide flexible booking options including one-way rides, round trips, hourly rentals, and full-day packages with transparent and affordable pricing. Our fleet includes well-maintained air-conditioned sedans, spacious SUVs, luxury cars, and tempo travelers suitable for solo travelers, families, and groups. With professional drivers familiar with Mumbai’s roads, punctual pickups from any location, and 24/7 customer support, Omshree Cab makes online taxi booking in Mumbai simple, reliable, and stress-free.",

topPlaces: [
  {
    title: "Gateway of India",
    description:
      "Gateway of India is one of Mumbai’s most famous landmarks and a major tourist attraction overlooking the Arabian Sea. Built during the British era, this grand monument attracts thousands of visitors every day who come to admire the architecture, take photographs, and enjoy boat rides to nearby Elephanta Island. The surrounding Colaba area is lively with cafes, hotels, and street vendors, making it a popular starting point for sightseeing in South Mumbai. Booking a taxi online makes it easy to reach the area comfortably without worrying about parking or navigating busy streets."
  },
  {
    title: "Marine Drive",
    description:
      "Marine Drive is a scenic coastal road stretching along the Arabian Sea and is popularly known as the Queen’s Necklace because the streetlights look like a necklace of pearls at night. It is a favorite place for locals and tourists who come here to relax, take evening walks, and enjoy breathtaking sunset views. The long promenade provides a peaceful escape from the busy city atmosphere. Taking a taxi allows visitors to enjoy a comfortable ride along the coastline while exploring nearby attractions in South Mumbai."
  },
  {
    title: "Juhu Beach",
    description:
      "Juhu Beach is one of the most popular beaches in Mumbai and a favorite spot for families, tourists, and locals. Visitors enjoy the lively atmosphere, sea breeze, and famous street food such as pav bhaji, bhel puri, and pani puri. The beach is especially beautiful during sunset when the sky turns orange over the Arabian Sea. A taxi ride makes traveling to Juhu Beach convenient and comfortable, especially during weekends when the area becomes crowded."
  },
  {
    title: "Siddhivinayak Temple",
    description:
      "Siddhivinayak Temple is one of the most important and revered temples in Mumbai dedicated to Lord Ganesha. Devotees from across India visit the temple to seek blessings and offer prayers. The temple is known for its spiritual atmosphere and attracts large crowds during festivals like Ganesh Chaturthi. Booking a taxi online helps visitors reach the temple easily and avoid the hassle of parking or navigating busy city roads."
  },
  {
    title: "Colaba Causeway",
    description:
      "Colaba Causeway is one of Mumbai’s most famous shopping streets and a paradise for bargain hunters. The vibrant market is filled with stalls selling clothes, accessories, jewelry, handicrafts, and souvenirs. Visitors also enjoy the lively cafes and restaurants located in the area. Using a taxi service makes it easier to reach this busy shopping destination and explore nearby landmarks like the Gateway of India and Kala Ghoda."
  },
  {
    title: "Haji Ali Dargah",
    description:
      "Haji Ali Dargah is a beautiful mosque and tomb located on a small island off the coast of Mumbai. The structure stands in the middle of the sea and is connected to the mainland by a narrow walkway that becomes visible during low tide. The dargah is visited by people of all religions who come to pray and experience the peaceful environment. A taxi ride ensures convenient travel to this spiritual landmark."
  },
  {
    title: "Elephanta Caves",
    description:
      "Elephanta Caves are ancient rock-cut caves located on Elephanta Island in Mumbai Harbour and are famous for their magnificent sculptures dedicated to Lord Shiva. Visitors reach the island by ferry from the Gateway of India and explore the impressive stone carvings and temples inside the caves. The site is known for its historical and cultural significance and attracts tourists from around the world. Taking a taxi makes it easy to reach the ferry departure point and begin the island journey comfortably."
  },
  {
    title: "Sanjay Gandhi National Park",
    description:
      "Sanjay Gandhi National Park is a large green forest area located within Mumbai city and offers a refreshing escape from urban life. The park is popular for nature walks, cycling, trekking, and wildlife spotting. It also houses the ancient Kanheri Caves carved into rock by Buddhist monks centuries ago. Visitors enjoy spending time in nature while exploring historical sites. A taxi ride provides convenient access to the park located in Borivali."
  },
  {
    title: "Taraporewala Aquarium",
    description:
      "Taraporewala Aquarium is one of the oldest aquariums in India and a popular attraction on Marine Drive. It features a wide variety of marine and freshwater fish displayed in modern tanks and exhibits. Visitors enjoy watching colorful sea creatures and learning about marine life. Traveling by taxi allows tourists to easily visit the aquarium while exploring the Marine Drive area."
  },
  {
    title: "Hanging Gardens",
    description:
      "Hanging Gardens, also known as Pherozeshah Mehta Gardens, are beautifully landscaped terraced gardens located on Malabar Hill. The gardens offer panoramic views of Marine Drive and the Arabian Sea. Visitors come here for relaxation, photography, and enjoying the peaceful greenery. A taxi ride makes it easy to reach this scenic location and include it in a South Mumbai sightseeing trip."
  }
],




services: [
{
name: "Online Taxi Booking Mumbai",
description: "Online taxi booking in Mumbai allows passengers to reserve a ride quickly and conveniently using digital booking platforms. Our service provides instant confirmation and reliable transportation across the city. Comfortable AC sedans and SUVs ensure smooth travel through busy Mumbai roads and highways. Professional drivers ensure punctual pickup and safe driving during the journey. Pickup services are available from homes, hotels, offices, railway stations, and Mumbai airport terminals. Ideal for business travel, tourism, and daily commuting. Flexible ride scheduling allows passengers to book taxis anytime. Transparent pricing ensures a hassle-free taxi booking experience."
},
{
name: "Online Cab Booking Mumbai",
description: "Online cab booking in Mumbai offers quick and convenient transportation for passengers traveling across the city or nearby destinations. Our fleet includes AC sedans, SUVs, and premium vehicles suitable for comfortable travel. Professional drivers ensure safe driving and punctual pickup services. Pickup is available from homes, offices, hotels, railway stations, and airport terminals across Mumbai. Ideal for daily commuting, airport transfers, and outstation trips. Spacious interiors provide relaxed seating during travel. Flexible booking options allow easy ride scheduling. Reliable cab services ensure smooth and comfortable journeys."
},
{
name: "Taxi Booking Online Mumbai",
description: "Taxi booking online in Mumbai provides easy and instant ride reservations for passengers seeking comfortable transportation. Our modern AC vehicles ensure pleasant travel across the city and surrounding areas. Professional drivers ensure safe driving and timely arrival at destinations. Pickup services are available across Mumbai including homes, offices, hotels, and airport terminals. Ideal for business travelers, tourists, and families. Spacious seating ensures comfortable journeys throughout the trip. Flexible travel scheduling allows passengers to plan rides easily. Reliable taxi booking ensures smooth transportation."
},
{
name: "Cab Booking Online Mumbai",
description: "Cab booking online in Mumbai offers convenient digital reservations for passengers needing quick transportation. Our AC vehicles provide comfortable travel through busy city roads and highways. Professional drivers ensure punctual pickup and safe driving throughout the journey. Pickup services are available across Mumbai including residential areas, offices, hotels, and airports. Ideal for corporate travel, tourism trips, and daily commuting. Spacious interiors ensure relaxed seating for passengers. Flexible ride scheduling allows convenient travel planning. Reliable cab booking ensures safe and dependable travel."
},
{
name: "Book Taxi Online Mumbai",
description: "Book taxi online in Mumbai for quick and reliable transportation anywhere within the city. Our fleet includes AC sedans and SUVs suitable for comfortable city travel and short highway trips. Professional drivers ensure safe driving and punctual pickup services. Pickup is available from homes, offices, hotels, railway stations, and airport terminals across Mumbai. Ideal for business travelers, tourists, and local commuters. Comfortable seating ensures relaxed journeys during travel. Flexible booking options allow passengers to schedule rides easily. Reliable taxi booking ensures smooth transportation."
},
{
name: "Book Cab Online Mumbai",
description: "Book cab online in Mumbai to enjoy easy and convenient transportation for city and outstation travel. Our AC vehicles ensure comfortable travel through Mumbai's busy roads and highways. Professional drivers ensure safe driving and punctual pickup services. Pickup services are available from homes, offices, hotels, and airport terminals across Mumbai. Ideal for daily commuting, airport transfers, and tourism travel. Spacious seating ensures comfortable journeys for passengers. Flexible booking options allow quick ride scheduling. Reliable cab booking ensures smooth and safe transportation."
},
{
name: "Instant Cab Booking Mumbai",
description: "Instant cab booking in Mumbai provides quick transportation solutions for passengers needing immediate rides. Our fleet includes comfortable AC sedans and SUVs suitable for city travel. Professional drivers ensure fast pickup and safe driving during the journey. Pickup services are available across Mumbai including residential areas, offices, hotels, and airport terminals. Ideal for urgent travel, business meetings, and airport transfers. Comfortable interiors ensure relaxed seating for passengers. Flexible booking options allow instant ride confirmation. Reliable cab services ensure convenient travel anytime."
},
{
name: "Online Airport Taxi Booking Mumbai",
description: "Online airport taxi booking in Mumbai offers convenient transportation for travelers arriving or departing from Mumbai Airport. Our AC vehicles ensure comfortable travel between airport terminals and city destinations. Professional drivers track flight timings to provide punctual pickup and drop services. Pickup is available from Terminal 1 and Terminal 2 of Mumbai Airport. Ideal for business travelers, tourists, and families. Spacious seating ensures comfortable airport transfers. Flexible booking options allow advance ride reservations. Reliable airport taxi services ensure stress-free travel."
},
{
name: "Online Car Booking Mumbai",
description: "Online car booking in Mumbai provides convenient vehicle reservations for passengers traveling within the city or nearby destinations. Our fleet includes sedans, SUVs, and premium vehicles suitable for different travel needs. Professional drivers ensure safe driving and punctual pickup services. Pickup services are available across Mumbai including homes, hotels, offices, and airports. Ideal for corporate travel, tourism visits, and personal trips. Comfortable interiors ensure relaxed journeys. Flexible booking options allow convenient ride scheduling. Reliable car booking ensures smooth transportation."
},
{
name: "Online Taxi Service Mumbai",
description: "Online taxi service in Mumbai provides easy digital ride booking for passengers needing reliable city transportation. Our AC vehicles ensure smooth travel through busy Mumbai roads and highways. Professional drivers ensure safe driving and punctual pickup services. Pickup services are available across Mumbai including residential areas, offices, hotels, and airports. Ideal for business travel, tourism visits, and daily commuting. Spacious interiors ensure comfortable seating during travel. Flexible booking options allow quick ride scheduling. Reliable taxi services ensure safe transportation."
},
{
name: "Online Outstation Cab Booking Mumbai",
description: "Online outstation cab booking in Mumbai offers reliable transportation for travelers planning long-distance trips. Our fleet includes AC sedans, SUVs, and luxury vehicles suitable for highway travel. Professional drivers ensure safe driving and timely arrival at destinations. Pickup services are available across Mumbai including homes, hotels, offices, and airports. Ideal for family vacations, pilgrimage tours, and weekend trips. Spacious seating ensures comfort during long journeys. Flexible one-way and round-trip options allow convenient travel planning. Reliable outstation cab booking ensures smooth travel."
},
{
name: "Online One Way Cab Booking Mumbai",
description: "Online one way cab booking in Mumbai allows passengers to travel to their destination without paying return trip charges. This option is ideal for airport transfers, intercity travel, and personal trips. Comfortable AC sedans and SUVs ensure relaxed travel conditions. Professional drivers ensure safe driving and punctual pickup services. Pickup services are available across Mumbai including homes, hotels, and airports. Ideal for business travelers and tourists. Flexible scheduling allows passengers to book rides easily. Reliable one-way cab services ensure affordable transportation."
},
{
name: "Online Round Trip Cab Booking Mumbai",
description: "Online round trip cab booking in Mumbai offers convenient travel for passengers planning return journeys. Flexible scheduling allows travelers to plan trips without worrying about return transportation. Comfortable AC vehicles ensure relaxed travel during the entire journey. Professional drivers remain available for return travel as per passenger timing. Pickup services are available across Mumbai including homes, offices, hotels, and airports. Ideal for tourism travel, family visits, and business trips. Spacious seating ensures comfortable journeys. Reliable round trip cab booking ensures smooth travel planning."
}
],

tableData: [
["Online Taxi Booking Mumbai","Online Cab Booking Mumbai"],
["Taxi Booking Online Mumbai","Cab Booking Online Mumbai"],
["Book Taxi Online Mumbai","Book Cab Online Mumbai"],
["Instant Cab Booking Mumbai","Online Airport Taxi Booking Mumbai"],
["Online Car Booking Mumbai","Online Taxi Service Mumbai"],
["Online Outstation Cab Booking Mumbai","Online One Way Cab Booking Mumbai"],
["Online Round Trip Cab Booking Mumbai","Mumbai Taxi Booking Online"]
],



whychoose: [
  {
    WhyChooseheading: "Easy Online Booking",
    WhyChoosedescription: "Omshree Cabs offers a simple and quick online taxi booking system for Mumbai travelers. Customers can easily book a cab through our website or phone and receive instant confirmation for their ride."
  },
  {
    WhyChooseheading: "Transparent Pricing",
    WhyChoosedescription: "We provide clear and transparent pricing for online taxi bookings in Mumbai. All charges including per-kilometer fare, tolls, and travel packages are explained before confirming your booking."
  },
  {
    WhyChooseheading: "24/7 Online Cab Availability",
    WhyChoosedescription: "Our online taxi booking service in Mumbai is available 24/7. Whether you need a late-night ride, airport transfer, or early morning cab, Omshree Cabs is always ready to serve."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "Our fleet includes well-maintained and fully air-conditioned vehicles that are regularly cleaned and sanitized to ensure a comfortable ride for passengers."
  },
  {
    WhyChooseheading: "Flexible Travel Options",
    WhyChoosedescription: "We offer multiple travel options including local city rides, airport transfers, outstation cabs, and corporate travel bookings so customers can plan their trips conveniently."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs provides a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, and premium vehicles suitable for solo travelers, families, and business trips."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Mumbai",
    WhyChoosedescription: "We provide doorstep pickup from homes, offices, hotels, railway stations, and airports anywhere in Mumbai, making online taxi booking convenient and hassle-free."
  },
  {
    WhyChooseheading: "Reliable Online Taxi Service",
    WhyChoosedescription: "Omshree Cabs is trusted by customers for reliable online taxi booking in Mumbai. Our punctual drivers, comfortable vehicles, and professional support ensure a smooth travel experience."
  }
]
};

const faqData = [
  { question: "How can I book a taxi online in Mumbai?", answer: "You can easily book a taxi online through the Omshree Cabs website or by contacting our booking number for instant confirmation." },
  { question: "Is online taxi booking available 24 hours?", answer: "Yes, our online taxi booking service in Mumbai is available 24/7 for local travel, airport transfers, and outstation trips." },
  { question: "Do you provide airport taxi booking online?", answer: "Yes, customers can book airport pickup and drop taxis online for Mumbai Airport." },
  { question: "Which vehicles are available for online taxi booking?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, and premium vehicles depending on your travel needs." },
  { question: "Can I book an outstation taxi online from Mumbai?", answer: "Yes, Omshree Cabs provides online booking for outstation travel to cities like Pune, Nashik, Surat, and many more." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Omshree Cabs are fully air-conditioned for comfortable travel." },
  { question: "Is advance online booking recommended?", answer: "Yes, advance booking is recommended especially during peak hours, weekends, and holidays." },
  { question: "Do you provide corporate taxi booking services?", answer: "Yes, Omshree Cabs provides corporate taxi booking services for business meetings, employee travel, and airport transfers." },
  { question: "Can I schedule a taxi for a specific time?", answer: "Yes, customers can schedule taxi bookings in advance for their preferred pickup time." },
  { question: "Are vehicles sanitized before travel?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohit Shah",
    feedback:
      "Booking a taxi online with Omshree Cabs in Mumbai was very easy. The cab arrived on time and the journey was comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Patil",
    feedback:
      "I used Omshree Cabs for online taxi booking in Mumbai for an airport transfer. The service was punctual and the driver was very professional.",
    rating: 5
  }
];





















































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];












const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Online Taxi Booking Mumbai",
  "description": "Omshree Cab offers convenient online taxi booking in Mumbai. Book cabs for local travel, airport transfers, one-way trips, round trips, and outstation travel. Instant online booking, affordable fares, and reliable cab service across Mumbai.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "4800"
  }
};





  return (
    <div>
      

<Helmet>
  <title>Online Taxi Booking Mumbai | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Omshree Cab provides easy online taxi booking in Mumbai. Book cabs for local, airport, one-way, round trip, and outstation travel. Affordable fares and reliable online cab service across Mumbai." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/33.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Onlinetaxibookingmumbai;